import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import * as classnames from 'classnames';
import './stale-indicator.sass';
import { getStaleState } from 'console/idle/selectors';
export const StaleIndicator = memo(function StaleIndicator() {
    const show = useAppSelector(getStaleState);
    return (_jsxs("div", { className: classnames('stale-indicator', {
            'stale-indicator-visible': show,
        }), children: [_jsx("span", { className: "stale-indicator-icon" }), _jsx("span", { children: "\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435..." })] }));
});
